import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { DormitorySpecialCaseResponse, ForeignLanguageResponse } from "../../models/dtos";

export const dormitorySpecialCasesApi = createApi({
  reducerPath: "dormitorySpecialCases",
  baseQuery: baseAuthQuery("DormitorySpecialCases"),
  tagTypes: ["DormitorySpecialCases"],
  endpoints: (builder) => ({
    getDormitorySpecialCases: builder.query<ApiResponse<DormitorySpecialCaseResponse[]>, void>({
      query: () => "",
      providesTags: ["DormitorySpecialCases"],
    }),
  }),
});
